<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-skeleton :loading="!data" :row="15">
      <div v-if="data" class="TopClassRect">
        <van-row class="line">
          <van-col span="14"><span :style="'color:'+GetColorMain()">班级: </span>{{ data.course.title }}</van-col>
          <van-col span="10"><span :style="'color:'+GetColorMain()">课程: </span>{{ data.course.level }}</van-col>
        </van-row>
        <van-row class="line">
          <van-col span="14"><span :style="'color:'+GetColorMain()">名称: </span>{{ data.course.address }}</van-col>
          <van-col span="10"><span :style="'color:'+GetColorMain()">开课日期: </span>{{ formatDate(data.course.startDate,"yyyy/MM/dd") }}</van-col>
        </van-row>
        <van-row class="line">
          <van-col span="24"><span :style="'color:'+GetColorMain()">操作: </span>
            <van-button type="danger" class="classButton" :loading="buttonLoading" size="mini" @click="onDeleteClass">删除班级</van-button>
            <van-button type="primary" class="classButton" size="mini" @click="onAddClassStudent">添加学员</van-button>
          </van-col>
        </van-row>
      </div>
      <template v-if="data">
        <div v-for="(student,j) in data.students" :key="student.studentId" class="StudentRect">
          <van-row class="line">
            <van-col span="24" class="rigth">
              <van-tag v-if="!student.isReg" style="margin-left:0.5em" :color="GetColorMain()">未注册</van-tag>
              <van-tag v-if="!student.isAccept" style="margin-left:0.5em" :color="GetColorSecondary()">未确认</van-tag>
            </van-col>
          </van-row>
          <van-row class="line">
            <van-col span="14"><span :style="'color:'+GetColorMain()">邮箱: </span>{{ student.emailAddress }}</van-col>
            <van-col span="10"><span :style="'color:'+GetColorMain()">姓名: </span>{{ student.name }}</van-col>
          </van-row>
          <van-row class="line">
            <van-col span="14"><span :style="'color:'+GetColorMain()">注册日期: </span>{{ formatDate(student.regDate,"yyyy/MM/dd") }}</van-col>
            <van-col span="10"><span :style="'color:'+GetColorMain()">状态: </span><van-tag :color="GetColorMain()" plain>{{ student.status }}</van-tag></van-col>
          </van-row>
          <van-row v-if="student.level" class="line">
            <van-col span="14"><span :style="'color:'+GetColorMain()">证书级别: </span>{{ student.level }}</van-col>
            <van-col span="10"><span :style="'color:'+GetColorMain()">证书编号: </span>{{ student.certificateId?student.certificateId:'-' }}</van-col>
          </van-row>
          <van-row class="line">
            <van-col span="14"><span :style="'color:'+GetColorMain()">课程单元: </span></van-col>
          </van-row>
          <van-row v-for="(unit,index) in data.unit" :key="index" class="line">
            <van-col span="24">
              <span>{{ unit.v }}: </span>
              <van-checkbox
                v-model="data.students[j].unit[index]"
                shape="square"
                :disabled="student.status==='Pending Payment'||student.status==='Certified'"
                :checked-color="GetColorMain()"
                class="checkBoxUnit"
                @change="student.isCertificate =false"
              /></van-col>
          </van-row>
          <van-row v-if="student.allFinish && student.status!=='Pending Payment'&&student.status!=='Certified'" class="line">
            <van-col span="24">
              <span>签发证书: </span>
              <van-checkbox v-model="data.students[j].isCertificate" shape="square" :checked-color="GetColorMain()" class="checkBoxUnit" @change="isCertificate =true" />
            </van-col>
          </van-row>

          <van-row class="line">
            <van-col span="24"><span :style="'color:'+GetColorMain()">操作: </span>
              <van-button v-if="!student.isReg" type="danger" class="classButton" :loading="buttonLoading" size="mini" @click="onDeleteStundet(student.aidaStudentId)">删除学员</van-button>
              <van-button v-if="!student.isReg" type="primary" class="classButton" :loading="buttonLoading" size="mini" @click="onRegStundet(student.aidaStudentId)">协助注册</van-button>
              <van-button v-if="student.isReg && student.isAccept && student.status==='Pending Payment'" type="warning" class="classButton" :loading="buttonLoading" size="mini" @click="onPayCertificate(student.aidaStudentId)">支付签证费</van-button>

              <van-button v-if="student.isReg &&!student.isAccept" type="primary" class="classButton" :loading="buttonLoading" size="mini" @click="onConfirmStundet(student.aidaStudentId)">确认课程</van-button>
            </van-col>
          </van-row>

        </div>
      </template>
    </van-skeleton>
    <div class="emptyRect" />
    <div class="downButton">
      <van-row gutter="20">
        <van-col span="12"><van-button type="primary" class="classButton" :disabled="true || !isCertificate" style="width:100%" :color="GetColorSecondary()" :loading="buttonLoading" size="normal" @click="onSubjcetCertificate">签发证书(暂未开放)</van-button></van-col>
        <van-col span="12"><van-button type="primary" class="classButton" style="width:100%" :color="GetColorMainBack()" :loading="buttonLoading" size="normal" @click="onSubjcetProgress">保存进度</van-button></van-col>
      </van-row>

    </div>
    <aidaClassStudentAdd v-model="addClassStudentClassId" @reload="init" />
    <aidaStudentReg v-model="regStudentStudentId" @reload="init" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Tag, Button, Skeleton, Checkbox, Dialog } from 'vant'
import TopBar from '@/components/TopBar'
import { isEmptyStr, MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import aidaClassStudentAdd from '@/views/pro/aida/aidaClassStudentAdd'
import aidaStudentReg from '@/views/pro/aida/aidaStudentReg'
export default {
  components: {
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Skeleton.name]: Skeleton,
    [Checkbox.name]: Checkbox,
    [Dialog.name]: Dialog,
    TopBar,
    aidaClassStudentAdd,
    aidaStudentReg
  },
  data() {
    return {
      titleTop: '',
      title: 'AIDA班级管理',
      backurl: '/pro/aidaHome',
      id: undefined,
      data: undefined,
      buttonLoading: false,
      addClassStudentClassId: undefined,
      regStudentStudentId: undefined,
      isCertificate: false
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.id = this.$route.params.id
    this.init()
  },
  methods: {
    isEmptyStr,
    MyNotify,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init() {
      this.data = undefined
      request({
        url: '/Pro/getAdiaClass',
        method: 'post',
        params: { id: this.id }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.isCertificate = false
        // 处理课程单元
        response.data.students.forEach(student => {
          student.unit = [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false]
          student.allFinish = true
          student.isCertificate = false
          if (student.finishUnits) {
            var list = student.finishUnits.split(',')
            for (var i = 0; i < response.data.unit.length; i++) {
              for (var j = 0; j < list.length; j++) {
                if (list[j] === response.data.unit[i].k) {
                  student.unit[i] = true
                }
              }
              if (!student.unit[i]) {
                student.allFinish = false
                console.log('失败了2', response.data.unit)
                console.log('失败了3', list)
                console.log('失败了1', student)
                console.log('失败了', i)
              }
            }
          }
        })
        this.data = response.data
      })
    },
    onAddClassStudent() {
      this.addClassStudentClassId = this.id
    },
    onRegStundet(studentId) {
      this.regStudentStudentId = studentId
    },
    onPayCertificate(studentId) {
      Dialog.confirm({
        title: '支付签发证书',
        message: '是否要跳转PayPal支付该证书订单?',
        cancelButtonText: '取消',
        confirmButtonText: '前往支付'
      }).then(() => {
        this.buttonLoading = true
        request({
          url: '/Pro/getPayUrlStudentCertificate',
          method: 'post',
          params: { id: studentId }
        }).then(Response => {
          this.buttonLoading = false
          if (!Response.success) {
            return
          }
          MyNotify('success', '生成成功，正在跳转!支付成功后请刷新查看!', 5000)
          window.location.href = Response.data
          return
        })
      })
    },
    onDeleteClass() {
      Dialog.confirm({
        title: '删除班级',
        message: '删除将会同步删除Aida系统中这个班级，只有没有学员的班级才可以删除，是否要删除这个班级?',
        cancelButtonText: '取消',
        confirmButtonText: '删除'
      }).then(() => {
        this.buttonLoading = true
        request({
          url: '/Pro/deleteClassAida',
          method: 'post',
          params: { id: this.id }
        }).then(Response => {
          this.buttonLoading = false
          if (!Response.success) {
            return
          }
          MyNotify('success', '删除班级成功', 2000)
          window.history.length > 1
            ? this.$router.go(-1)
            : this.$router.push(this.backUrl)
        })
      })
    },
    onDeleteStundet(studentId) {
      Dialog.confirm({
        title: '删除学员',
        message: '是否要删除这个学员?',
        cancelButtonText: '取消',
        confirmButtonText: '删除'
      }).then(() => {
        this.buttonLoading = true
        request({
          url: '/Pro/deleteStudentAida',
          method: 'post',
          params: { id: studentId }
        }).then(Response => {
          this.buttonLoading = false
          if (!Response.success) {
            return
          }
          MyNotify('success', '删除学员成功', 2000)
          this.init()
        })
      })
    },
    onConfirmStundet(studentId) {
      Dialog.confirm({
        title: '确认课程',
        message: '是否要确认这个课程?',
        cancelButtonText: '取消',
        confirmButtonText: '确认'
      }).then(() => {
        this.buttonLoading = true
        request({
          url: '/Pro/confirmStudentCourse',
          method: 'post',
          params: { id: studentId }
        }).then(Response => {
          this.buttonLoading = false
          if (!Response.success) {
            return
          }
          MyNotify('success', '确认成功', 2000)
          this.init()
        })
      })
    },
    getProgressPostData(isCertificate) {
      var data = {
        classId: this.id,
        student: []
      }
      this.data.students.forEach(student => {
        if (student.status !== 'Pending Payment' && student.status !== 'Certified') {
          var stu = {
            studentId: student.aidaStudentId,
            isCertificate: false,
            units: []
          }
          if (isCertificate && student.isCertificate) {
            stu.isCertificate = true
          }
          for (var i = 0; i < this.data.unit.length; i++) {
            if (student.unit[i]) {
              stu.units.push(this.data.unit[i].k)
            }
          }
          data.student.push(stu)
        }
      })
      return data
    },
    onSubjcetProgress() {
      var data = this.getProgressPostData(false)
      this.buttonLoading = true
      request({
        url: '/Pro/SetStudentProgress',
        method: 'post',
        data: data
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        MyNotify('success', '保存进度成功')
        this.init()
      })
    },
    onSubjcetCertificate() {
      Dialog.confirm({
        title: '签发证书',
        message: '是否要签发证书？一旦申请无法撤销，将会在Aida系统中留下不可删除的数据!',
        cancelButtonText: '取消',
        confirmButtonText: '确认'
      }).then(() => {
        this.buttonLoading = true
        var data = this.getProgressPostData(true)
        request({
          url: '/Pro/setStudentCertificate',
          method: 'post',
          data: data
        }).then(Response => {
          this.buttonLoading = false
          if (!Response.success) {
            return
          }
          MyNotify('success', '签发证书成功')
          this.init()
        })
      })
    }
  }
}
</script>
<style scoped>
.TopClassRect{
    background-color: #fff;
    padding: 0.5em 1em;
}
.TopClassRect .line{
    padding: 0.25em 0;
    font-size: 0.8em;
}
.TopClassRect span{
    font-weight: 700;
}
.TopClassRect .classButton{
  margin-right: 1em;
}
.StudentRect{
    margin-top: 0.5em;
    background-color: #fff;
    padding: 0.5em 1em;
}
.StudentRect .line{
    padding: 0.25em 0;
    font-size: 0.8em;
    word-wrap: break-word;
}
.StudentRect span{
    font-weight: 700;
}
.checkBoxUnit{
    display:inline-block;
    vertical-align:middle;
    margin-left: 0.5em;
}
.emptyRect{
  height: 5em;
}
.downButton{
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 0.5em 1em;
  height: 3em;
  background-color: #fff;
}
</style>
